module.exports = __webpack_public_path__ + "static/media/inv-award-pic.a782ab2e.jpg";